export enum BcMode {
  Snow = 'snow',
  Trail = 'trail',
  Mtb = 'mtb',
  Climb = 'climb',
}

export enum OffroadMode {
  Dirt = 'dirt',
  Snow = 'snow',
  Composite = 'composite',
}

export enum FishMode {
  Freshwater = 'freshwater',
}

export enum AllModes {
  Snow = 'snow',
  Trail = 'trail',
  Mtb = 'mtb',
  Climb = 'climb',
  Dirt = 'dirt',
  Freshwater = 'freshwater',
}

export type Mode = BcMode | OffroadMode | FishMode
